var map = {
	"./locale-provider/bg_BG.tsx": 1046,
	"./locale-provider/ca_ES.tsx": 1047,
	"./locale-provider/cs_CZ.tsx": 1048,
	"./locale-provider/de_DE.tsx": 1049,
	"./locale-provider/el_GR.tsx": 1050,
	"./locale-provider/en_GB.tsx": 1051,
	"./locale-provider/en_US.tsx": 1052,
	"./locale-provider/es_ES.tsx": 1053,
	"./locale-provider/et_EE.tsx": 1054,
	"./locale-provider/fa_IR.tsx": 1055,
	"./locale-provider/fi_FI.tsx": 1056,
	"./locale-provider/fr_BE.tsx": 1057,
	"./locale-provider/fr_FR.tsx": 1058,
	"./locale-provider/it_IT.tsx": 1059,
	"./locale-provider/ja_JP.tsx": 1060,
	"./locale-provider/ko_KR.tsx": 1061,
	"./locale-provider/nb_NO.tsx": 1062,
	"./locale-provider/nl_BE.tsx": 1063,
	"./locale-provider/nl_NL.tsx": 1064,
	"./locale-provider/pl_PL.tsx": 1065,
	"./locale-provider/pt_BR.tsx": 1066,
	"./locale-provider/pt_PT.tsx": 1067,
	"./locale-provider/ru_RU.tsx": 1068,
	"./locale-provider/sk_SK.tsx": 1069,
	"./locale-provider/sr_RS.tsx": 1070,
	"./locale-provider/sv_SE.tsx": 1072,
	"./locale-provider/th_TH.tsx": 1073,
	"./locale-provider/tr_TR.tsx": 1074,
	"./locale-provider/vi_VN.tsx": 1075,
	"./locale-provider/zh_TW.tsx": 1076
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 996;



//////////////////
// WEBPACK FOOTER
// ./components ^\.\/locale-provider\/.+_.+\.tsx$
// module id = 996
// module chunks = 0